<div class="video-container">
  <h3 *ngIf="value && value.title" class="title">{{ value.title }}</h3>
  <div class="video-viewer">
    <grid-ui-body-item-video-player [value]="value"></grid-ui-body-item-video-player>
  </div>
  <h4 *ngIf="value && value.description" class="description">{{ value.description }}</h4>
</div>
